import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out

  useEffect(() => {
    API.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await API.post("/auth/login", { email, password });
    setUser(r.data);
    return r.data;
  }, []);

  const register = useCallback(async (name, email, password) => {
    const r = await API.post("/auth/register", { name, email, password });
    setUser(r.data);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    await API.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  const toggleWishlist = useCallback(async (productId) => {
    const r = await API.post(`/auth/wishlist/${productId}`);
    setUser((u) => {
      if (!u) return u;
      const wl = u.wishlist || [];
      return { ...u, wishlist: wl.includes(productId) ? wl.filter((x) => x !== productId) : [...wl, productId] };
    });
    return r.data.wishlisted;
  }, []);

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, toggleWishlist }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
